import { render, staticRenderFns } from "./title-checkbox.vue?vue&type=template&id=3ff10766"
import script from "./title-checkbox.vue?vue&type=script&lang=js"
export * from "./title-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports